<app-pcbread-crumb [data]="breadCrumb"></app-pcbread-crumb>

<div class="card p-2 animate__animated animate__backInDown">
  <app-pctable-action
    [data]="action"
    [header]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable-action>

  <app-pctable
    [data]="data"
    [entityField]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable>

  <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
  </app-pcpaging>

  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</div>

<ng-template #AddUserModal let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "User" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-6">
        <div class="edit-form">
          <label class="form-label" for="user-profile-firstname">
            {{ "FirstName" | translate }}
          </label>
          <div class="validation-alert-input">
            <p>{{ user.firstNameValidation }}</p>
          </div>
          <input
            id="firstname"
            class="input-design form-control"
            [ngClass]="{ 'is-invalid': user.firstNameValidation }"
            type="text"
            [(ngModel)]="user.firstName"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="edit-form">
          <label class="form-label" for="user-profile-lastname">
            {{ "LastName" | translate }}
          </label>
          <div class="validation-alert-input">
            <p>{{ user.lastNameValidation }}</p>
          </div>
          <input
            id="lastname"
            class="input-design form-control"
            [ngClass]="{ 'is-invalid': user.lastNameValidation }"
            type="text"
            [(ngModel)]="user.lastName"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="edit-form">
          <label class="form-label" for="user-profile-birthday">
            {{ "username" | translate }}
          </label>
          <div class="validation-alert-input">
            <p>{{ user.userNameValidation }}</p>
          </div>
          <input
            id="username"
            type="text"
            class="form-control"
            [ngClass]="{ 'is-invalid': user.userNameValidation }"
            [(ngModel)]="user.username"
            [ngModelOptions]="{ standalone: true }"
            placeholder="{{ 'username' | translate }}"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="edit-form">
          <label class="form-label" for="user-profile-national-code">
            {{ "password" | translate }}
          </label>
          <div class="validation-alert-input">
            <p>{{ user.passwordValidation }}</p>
          </div>
          <input
            id="password"
            class="input-design form-control"
            [ngClass]="{ 'is-invalid': user.passwordValidation }"
            type="text"
            [(ngModel)]="user.password"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="edit-form">
          <label class="form-label" for="user-profile-mobile-number">
            {{ "position" | translate }}
          </label>
          <app-drop-down
            [dropDownData]="positionList"
            [fieldName]="['name']"
            [addUrl]="'Position'"
            [isValid]="
              user.positionIdValidation == '' ||
              user.positionIdValidation == null
            "
            [buttonClass]="'Focusable'"
            (ngModelValueChange)="changePosition($event)"
          ></app-drop-down>
        </div>
      </div>
      <div class="col-6">
        <div class="edit-form">
          <label class="form-label" for="user-profile-phone-number">
            {{ "DrugStore" | translate }}
          </label>
          <app-drop-down
            [dropDownData]="DrugStoreList"
            [isValid]="
              user.drugStoreIdValidation == '' ||
              user.drugStoreIdValidation == null
            "
            [buttonClass]="'Focusable'"
            (ngModelValueChange)="changeDrugStore($event)"
          ></app-drop-down>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer border-top justify-content-center p-3">
    <button type="button" class="btn btn-primary" (click)="submitAdd()">
      {{ "Save" | translate }}
    </button>

    <button
      type="button"
      class="btn btn-label-secondary"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    >
      {{ "Cancel" | translate }}
    </button>
  </div>
</ng-template>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>

<app-pcconfrim-modal
  *ngIf="modalDeleteConfirm"
  (childEvent)="parentAction($event)"
  [inputModel]="confirmModal"
></app-pcconfrim-modal>

<app-pcsetting-modal (parentAction)="parentAction($event)" [fields]="fields">
</app-pcsetting-modal>

<app-change-password-modal
  [needOldPassword]="false"
  [userId]="thisValue?.id"
  (parentAction)="parentAction($event)"
></app-change-password-modal>

<app-permission-modal
  [userId]="thisValue?.id"
  (parentAction)="parentAction($event)"
></app-permission-modal>
